var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_vm.hasNoUser ? _c('v-sheet', {
    attrs: {
      "width": "400"
    }
  }, [_c('v-card-title', [_vm._v(" 로그인이 필요한 페이지입니다 ")]), _c('v-card-text', [_c('login-card')], 1)], 1) : _vm.isNotPerson || _vm.isNotApplicant ? _c('v-sheet', [_c('v-card-title', [_vm._v("권한이 없습니다.")]), _c('v-card-text', [_vm._v(" 사용하실 수 없는 페이지입니다. ")]), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v("이전으로")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(" 로그아웃 ")])], 1)], 1) : _c('v-sheet', {
    staticClass: "fill-height",
    attrs: {
      "width": "1080",
      "max-width": "95%"
    }
  }, [_c('meeting-view-tabs', _vm._b({
    scopedSlots: _vm._u([{
      key: "tab-complete-actions",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "href": "/dashboard/schedules",
            "color": "primary"
          }
        }, [_vm._v("대시보드 가기")])];
      },
      proxy: true
    }])
  }, 'meeting-view-tabs', {
    meeting: _vm.meeting
  }, false))], 1), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "100",
      "width": "5",
      "color": "primary",
      "indeterminate": ""
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }